/**
 * French public holidays (métropole). Variable holidays anchored on Easter
 * computed via the Anonymous Gregorian algorithm (Computus).
 *
 * Alsace-Moselle specifics (Vendredi Saint, 26 décembre) are intentionally
 * excluded — most GW staff are outside that scope.
 */

function easter(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

const cache = new Map<number, Map<string, string>>();

/** Return the map of {ISO date → holiday name} for the given year. */
function holidaysFor(year: number): Map<string, string> {
  const hit = cache.get(year);
  if (hit) return hit;

  const e = easter(year);
  const m = new Map<string, string>();
  const set = (d: Date, name: string): void => {
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    m.set(iso, name);
  };

  // Fixed dates
  set(new Date(year, 0, 1), "Jour de l'An");
  set(new Date(year, 4, 1), "Fête du Travail");
  set(new Date(year, 4, 8), "Victoire 1945");
  set(new Date(year, 6, 14), "Fête nationale");
  set(new Date(year, 7, 15), "Assomption");
  set(new Date(year, 10, 1), "Toussaint");
  set(new Date(year, 10, 11), "Armistice");
  set(new Date(year, 11, 25), "Noël");

  // Easter-anchored.
  // Lundi de Pentecôte is intentionally excluded — it is treated as the
  // Journée de Solidarité (worked day) per Gatewatcher's policy, even though
  // it remains a jour férié légal in the Code du Travail.
  set(addDays(e, 1), "Lundi de Pâques");
  set(addDays(e, 39), "Ascension");

  cache.set(year, m);
  return m;
}

export function holidayName(d: Date): string | null {
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return holidaysFor(d.getFullYear()).get(iso) ?? null;
}

export function isHoliday(d: Date): boolean {
  return holidayName(d) !== null;
}
